// 通用配置「配置值」合法性校验（纯函数，便于单测）
// 规则对齐后端读取语义：
// - NUMBER：CommonConfigServiceImpl.getNumberConfig（含 . 走 toDouble 否则 toLong）
// - BOOLEAN：CommonConfigServiceImpl.getBooleanConfig（toBoolean()）
// 空值（trim 后为空串）一律视为通过：configValue 可选、留空存空串。

const NUMBER_PATTERN = /^[+-]?\d+(\.\d+)?$/;

function isValidJson(value: string): boolean {
    try {
        JSON.parse(value);
        return true;
    } catch {
        return false;
    }
}

export function validateConfigValue(
    configType: string,
    configValue: string | null | undefined
): boolean {
    const value = (configValue ?? '').trim();
    if (value === '') {
        return true;
    }
    switch (configType) {
        case 'JSON':
            return isValidJson(value);
        case 'NUMBER':
            return NUMBER_PATTERN.test(value) && Number.isFinite(Number(value));
        case 'BOOLEAN': {
            const lower = value.toLowerCase();
            return lower === 'true' || lower === 'false';
        }
        case 'STRING':
        default: {
            // STRING 下智能探测：值以 { 或 [ 开头时，按 JSON 校验合法性，
            // 便于抓出「类型声明为 STRING 但值实际是 JSON 且写错」的情况；
            // 其余（不以 {/[ 开头）作为普通字符串一律通过。
            const first = value[0];
            if (first === '{' || first === '[') {
                return isValidJson(value);
            }
            return true;
        }
    }
}
